.atm_vy_1ns9ob4{width:fit-content;}
.atm_1tgqd35_1pec9uq:hover{background:#ffffff;}
.atm_1nxlhud_euo1lb:hover{transition:all 0.2s ease;}
.atm_26_1j28jx2{background:transparent;}
.atm_l8_idpfg4{padding:0;}
.atm_9s_1txwivl{display:flex;}
.atm_vy_1osqo2v{width:100%;}
.atm_h_esu3gu.atm_h_esu3gu{align-items:flex-end;}
.atm_cx_1y44olf{gap:4px;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
